import { render, staticRenderFns } from "./lottery-goods-select-modal.vue?vue&type=template&id=172f13b6&scoped=true&"
import script from "./lottery-goods-select-modal.vue?vue&type=script&lang=js&"
export * from "./lottery-goods-select-modal.vue?vue&type=script&lang=js&"
import style0 from "./lottery-goods-select-modal.vue?vue&type=style&index=0&id=172f13b6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172f13b6",
  null
  
)

export default component.exports